(function () {
  ('use strict');

  // Navbar Toggle
  const navbarButton = document.getElementById('menu-dropdown-toggle');
  const navbar = document.getElementById('header__main-nav');
  navbarButton.addEventListener('click', function () {
    navbar.classList.toggle('show');
    navbarButton.classList.toggle('close__icon');
    const expanded = this.getAttribute('aria-expanded') === 'true' || false;

    this.setAttribute('aria-expanded', !expanded);
    navbar.setAttribute('aria-hidden', expanded);
  });

  // Dropdowns with megamenu
  const childrenLinks = document.querySelectorAll(
    '.header__nav-item-link[aria-haspopup="true"]'
  );
  const megaMenus = document.querySelectorAll('.header__nav-mega-menu');

  if (!childrenLinks) return;

  childrenLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const menuItem = e.target.parentNode;
      const megaMenu = menuItem.querySelector('.header__nav-mega-menu');

      // Close any other open mega menus
      megaMenus.forEach((menu) => {
        if (menu !== megaMenu) {
          menu.classList.remove('show');
          const link = menu.parentNode.querySelector(
            '.header__nav-item-link[aria-haspopup="true"]'
          );
          link.setAttribute('aria-expanded', 'false');
          menu.setAttribute('aria-hidden', 'true');
        }
      });
      megaMenu.classList.toggle('show');
      const isExpanded = link.getAttribute('aria-expanded') === 'true';
      link.setAttribute('aria-expanded', !isExpanded);
      megaMenu.setAttribute('aria-hidden', isExpanded);
    });
  });

  // Prevent scrolling when mega menu is open
  const body = document.querySelector('body');
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.target.classList.contains('show')) {
        body.classList.add('mega-menu--open');
      } else {
        body.classList.remove('mega-menu--open');
      }
    });
  });

  megaMenus.forEach((menu) => {
    observer.observe(menu, {
      attributes: true,
      attributeFilter: ['class'],
    });
  });

  // Close mega menu when clicking outside
  document.addEventListener('click', (e) => {
    const target = e.target;
    if (!target.closest('.header__nav-item')) {
      megaMenus.forEach((menu) => {
        menu.classList.remove('show');
        const link = menu.parentNode.querySelector(
          '.header__nav-item-link[aria-haspopup="true"]'
        );
        link.setAttribute('aria-expanded', 'false');
        menu.setAttribute('aria-hidden', 'true');
      });
    }
  });
})();
